<div class="sidebar-overlay" [class.visible]="sidebarService.isOpen$ | async" (click)="closeSidebar()"></div>

<nav
  class="sidebar-drawer"
  [class.open]="sidebarService.isOpen$ | async"
  [class.floating]="variant === 'floating'"
  role="navigation"
  aria-label="Menú de navegación"
>
  <!-- Header del sidebar -->
  <div class="sidebar-header">
    <a class="sidebar-brand" routerLink="/home" (click)="closeSidebar()" aria-label="Ir al inicio de Metabridge">
      <span class="brand-name"><span class="brand-meta">META</span><span class="brand-bridge">BRIDGE</span></span>
    </a>
    <button type="button" class="sidebar-close-btn" (click)="closeSidebar()" aria-label="Cerrar menú">
      <app-sidebar-icon [open]="true"></app-sidebar-icon>
    </button>
  </div>

  <!-- Secciones de menú -->
  <div class="sidebar-body">
    <div *ngFor="let section of menuItems; trackBy: trackBySectionTitle" class="sidebar-section">
      <span class="sidebar-section-title">
        {{ section.title }}
      </span>

      <!-- El producto activo se elige aquí, sobre los módulos de la sección. -->
      <div *ngIf="isProductSection(section) && productOptions.length > 0" class="sidebar-product-select">
        <p-select
          [options]="productOptions"
          optionLabel="label"
          optionValue="id"
          [ngModel]="selectedProductId"
          (onChange)="onProductChange($event.value)"
          appendTo="body"
          styleClass="w-full"
          ariaLabel="Seleccionar producto"
        >
          <ng-template pTemplate="selectedItem" let-product>
            <div class="sidebar-product-option" *ngIf="product">
              <i [class]="product.icon"></i><span>{{ product.label }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-product>
            <div class="sidebar-product-option">
              <i [class]="product.icon"></i><span>{{ product.label }}</span>
            </div>
          </ng-template>
        </p-select>
      </div>

      <ul class="sidebar-menu" [ngClass]="{ expanded: section.expanded }">
        <ng-container *ngTemplateOutlet="menuList; context: { $implicit: section.submenu, depth: 0 }"></ng-container>
      </ul>
    </div>
  </div>

  <!-- Footer -->
  <div class="sidebar-footer">
    <ul class="sidebar-menu">
      <li class="sidebar-menu-item">
        <a routerLink="/home" (click)="closeSidebar()">
          <i class="pi pi-home"></i>
          <span class="menu-label">Inicio</span>
        </a>
      </li>
    </ul>
  </div>
</nav>

<ng-template #menuList let-items let-depth="depth">
  <li *ngFor="let item of items; trackBy: trackByMenuUrl" class="sidebar-menu-item" [class.sub-item]="depth > 0" [class.active]="isActive(item)" [class.has-children]="hasSubmenu(item)">
    <div *ngIf="hasSubmenu(item); else menuLink" class="sidebar-menu-trigger">
      <i *ngIf="item.icon" [class]="item.icon"></i>
      <span class="menu-label">{{ item.title }}</span>
    </div>

    <ng-template #menuLink>
      <a [routerLink]="navigationUrl(item)" (click)="closeSidebar()">
        <i *ngIf="item.icon" [class]="item.icon"></i>
        <span class="menu-label">{{ item.title }}</span>
      </a>
    </ng-template>

    <ul *ngIf="hasSubmenu(item)" class="sidebar-submenu" [ngClass]="{ expanded: item.expanded }">
      <ng-container *ngTemplateOutlet="menuList; context: { $implicit: item.submenu, depth: depth + 1 }"></ng-container>
    </ul>
  </li>
</ng-template>
